/* Bottom nav arrows for a horizontal scroller (used by the "Buy it again" row and
   the Best Sellers carousel). Each arrow bar has data-llm-slider-arrows and
   data-target = the id of the scrollable element. Clicking scrolls it ~2 cards,
   the arrows disable at the ends, and the bar hides when there's no overflow.
   Kept generic so both rows behave identically. */
(function () {
  function initBar(bar) {
    // The snippet is included once per slider, so this script can run more than
    // once — guard each bar so its listeners are only bound a single time.
    if (bar.dataset.arrowsInit) return;
    bar.dataset.arrowsInit = '1';
    var target = document.getElementById(bar.getAttribute('data-target'));
    if (!target) return;
    var prev = bar.querySelector('[data-dir="prev"]');
    var next = bar.querySelector('[data-dir="next"]');
    if (!prev || !next) return;

    // Overlay the arrows on the slider's SIDES (usual slider position) instead of
    // the bottom bar. Anchor to the slider's positioned .container wrapper, and
    // expose the slider's inset + card-photo centre so the arrows land at the
    // card-row edges, vertically centred on the photo.
    var anchor = target.closest('.container');
    if (anchor) {
      if (getComputedStyle(anchor).position === 'static') anchor.style.position = 'relative';
      anchor.appendChild(bar);
      bar.classList.add('llm-slider-arrows--overlay');
      var setPos = function () {
        /* ⚠️ TWO INSETS, MEASURED SEPARATELY — the row is not necessarily centred in its anchor.
           This used to set ONE `--llm-arrow-inset` from target.offsetLeft, and the CSS applied it
           to `left` on prev AND `right` on next. That only holds when the slider starts and ends
           flush with its .container, which is true of Best Sellers and NOT of the account band,
           where a 340px orders column sits to the left of the row.
           Measured on the live homepage 2026-10-19: anchor 248→1658, row 653→1625, inset 404px.
           The next arrow landed at 1254 (1658−404) — 372px inside the row's right edge, floating
           over the third card instead of sitting on the last one. Owner spotted it.
           offsetLeft also silently assumes the anchor is the offsetParent; comparing rects does
           not, which matters because the JS re-parents this bar into .container at runtime. */
        var aRect = anchor.getBoundingClientRect();
        var tRect = target.getBoundingClientRect();
        bar.style.setProperty('--llm-arrow-inset', (tRect.left - aRect.left) + 'px');
        bar.style.setProperty('--llm-arrow-inset-right', (aRect.right - tRect.right) + 'px');
        var media = target.querySelector('.card__media');
        if (media) {
          var mRect = media.getBoundingClientRect();
          var aRect = anchor.getBoundingClientRect();
          bar.style.setProperty('--llm-arrow-top', ((mRect.top - aRect.top) + mRect.height / 2) + 'px');
        }
      };
      setPos();
      window.addEventListener('resize', setPos);
      setTimeout(setPos, 500);
    }

    function step() {
      var item = target.querySelector('.slider__item, .llm-account-band__again-item, li');
      var w = item ? item.getBoundingClientRect().width : target.clientWidth * 0.4;
      return (w + 16) * 2;
    }
    function maxScroll() {
      return target.scrollWidth - target.clientWidth;
    }
    function update() {
      // Looping row, so the arrows never dead-end — just show/hide the bar based
      // on whether the row overflows at all.
      var max = maxScroll();
      bar.classList.toggle('is-ready', max > 4);
      // Fade the RIGHT edge only while the last card is cut off (more to scroll
      // right); never the left, and not once scrolled to the end.
      target.classList.toggle('llm-fade-right', max > 4 && target.scrollLeft < max - 2);
    }

    // A wrap can be a long way (Best Sellers has many products), so jump
    // instantly for big distances and animate only short ones.
    function goTo(pos) {
      var behavior = Math.abs(pos - target.scrollLeft) > target.clientWidth * 1.5 ? 'auto' : 'smooth';
      target.scrollTo({ left: pos, behavior: behavior });
    }

    // Loop: at the end, "next" wraps back to the start; at the start, "prev"
    // wraps to the end — so you can keep cycling through the products.
    prev.addEventListener('click', function () {
      if (target.scrollLeft <= 2) goTo(maxScroll());
      else target.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      if (target.scrollLeft >= maxScroll() - 2) goTo(0);
      else target.scrollBy({ left: step(), behavior: 'smooth' });
    });
    target.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // Images/cards can change width as they load; recheck shortly after load.
    setTimeout(update, 400);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-llm-slider-arrows]').forEach(initBar);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  /* Some sliders arrive AFTER this script has run — the Recently viewed section fetches
     its own markup and injects it with innerHTML, so its arrow bar never existed at
     DOMContentLoaded (and a <script src> inside injected HTML never executes, so it can't
     re-run this file either). Watch for bars added later and wire them up. initBar is
     guarded by data-arrows-init, so re-scanning is safe. */
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('[data-llm-slider-arrows]')) initBar(n);
        if (n.querySelectorAll) n.querySelectorAll('[data-llm-slider-arrows]').forEach(initBar);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
